/**
 * Master switch for the Activity Generation Status badge + its polling.
 *
 * Flip to `true` to re-enable:
 *   - the badge in the Course Builder editor row (ItemHeader.vue)
 *   - the badge in the student course menu (nested-list-item/Activity.vue)
 *   - the polling started by CourseTemplateEditor.vue and pages/courses/Course.vue
 *
 * Backend resources and endpoints stay live regardless — only the consumers
 * are gated, so re-enabling is a one-line change.
 */
export const ACTIVITY_GENERATION_STATUS_UI_ENABLED = true;
